// extracted by mini-css-extract-plugin
module.exports = {"cnt":"Uploader_cnt__hW1WL","btn":"Uploader_btn__22aIi"};